<template>
 <div class="row  mb-2">
    <div class="col-2 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
         {{ $t("demand.tabs.summary.details.externalReference") }}
      </label>
      <span class="font-weight margin-left color" >
        {{externalReferance}}
      </span>
    </div>
    <div class="col-3 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
       {{ $t("demand.tabs.summary.details.clientreference")}}
      </label>
      <span class="font-weight margin-left color" >
        {{clientReference}}
      </span>
    </div>
    <div class="col-2 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
        {{ $t("demand.tabs.summary.details.process")}}
      </label>
      <span class="font-weight margin-left color" >
        {{internalCode}}
      </span>
    </div>
    <div class="col-3 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
       {{ $t("demand.tabs.summary.details.status")}}
      </label>
      <span class="font-weight margin-left color" >
        {{orderStatus}}
      </span>
    </div>
 </div>
 <div class="row">
    <div class="col-2 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
        {{ $t("demand.tabs.summary.details.creationDate")}}
      </label>
      <span class="font-weight margin-left color" >
       {{effectiveDeliveryDate}}
      </span>
    </div>
    <div class="col-3 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
         {{ $t("demand.tabs.summary.details.initialDate")}}
      </label>
      <span class="font-weight margin-left color" >
       {{initialDeliveryDate}}
      </span>
    </div>
    <div class="col-2 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
         {{ $t("demand.tabs.summary.details.engagementDate")}}
      </label>
      <span class="font-weight margin-left color" >
        {{engagementDate}}
      </span>
    </div>
    <div class="col-3 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
        {{ $t("demand.tabs.summary.details.previsionalDate")}}
      </label>
      <span class="font-weight margin-left color" >
        {{previsionDeliveryDate}}
      </span>
    </div>
    <div class="col-2 mb-2">
      <label
        class="d-block font-semi-bold mb-0 font-size color font-weight">
         {{ $t("demand.tabs.summary.details.appointmentDate")}}
      </label>
      <span class="font-weight margin-left color" >
       {{appointementDate}}
      </span>
    </div>
 </div>
   
</template>

<script lang="ts">
import i18n from "@/i18n";
import store from "@/store";
import {Options, Vue} from "vue-class-component";


@Options({
  props: ["order"],
  components: {
  },
})
export default class summaryTabOrderDetails extends Vue {
  order?: any;
  get orderStatus() {
    const taskOrderStatus = store.state.taskModule.selectedTask?.variables?.orderStatus;
    const orderStatusUid = store.state.orderModule.order?.status?.resourceUid;

    const statusKey = taskOrderStatus || orderStatusUid;

    return statusKey
      ? i18n.global.t(`order.picklist.status.${statusKey}`)
      : "-";
  }
  get effectiveDeliveryDate() {
      return this.order && this.order.effectiveDeliveryDate 
            ? this.order.effectiveDeliveryDate 
            : "-";
  }
  get initialDeliveryDate(){
    return this.order && this.order.orderItems && this.order.orderItems[0] && this.order.orderItems[0].initialDeliveryDate 
            ? this.order.orderItems[0].initialDeliveryDate
            : "-";
  }
    get previsionDeliveryDate(){
    return this.order && this.order.orderItems && this.order.orderItems[0] && this.order.orderItems[0].previsionDeliveryDate 
            ? this.order.orderItems[0].previsionDeliveryDate
            : "-";
  }
   get engagementDate(){
    return "-";
  }
   get appointementDate(){
    return "-";
  }
  get externalReferance(){
    return this.order && this.order.orderItems && this.order.orderItems[0] && this.order.orderItems[0].externalReference 
            ? this.order.orderItems[0].externalReference
            : "-";
  }
    get internalCode() {
      return this.order && this.order.status && this.order.status.internalCode 
            ?  this.order.status && this.order.status.internalCode 
            : "-";
  }
   get clientReference() {
    const client = this.order && this.order.orderParties && this.order.orderParties.length
                   ? this.order.orderParties.filter((item:any) => item.orderParty && item.orderParty.role  && item.orderParty.role.resourceUid&& item.orderParty.role.resourceUid==="CUSTOMER")[0]
                   : null
      return client  && client.orderParty && client.orderParty.party && client.orderParty.party.rawData && client.orderParty.party.rawData.responseData  && client.orderParty.party.rawData.responseData.reference
             ? client.orderParty.party.rawData.responseData.reference
             : "-"
           
  }
}
 

</script>

<style scoped>
</style>
